import React from "react";
import SummaryPie from "./SummaryPie";

export default function AmountPerCategory(props) {
    const categorySelected = (categoryId, categoryDescription) => {
        props.categorySelected(categoryId, categoryDescription);
    };

    return props.items ? (
        <SummaryPie height={props.height} items={props.items} categorySelected={categorySelected} />
    ) : (
        <div />
    );
}
